import { comments } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
            <i className="ri-chat-quote-line"></i>
            真实反馈
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            读者热评
          </h2>
          <p className="text-foreground-500 text-sm mt-2">
            来自韩漫爱好者的真实声音
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {comments.map((comment) => (
            <article
              key={comment.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < comment.rating ? 'ri-star-fill text-secondary-500' : 'ri-star-line text-foreground-300'}`}
                  ></i>
                ))}
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed flex-1 mb-4">
                "{comment.content}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/70">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    width="40"
                    height="40"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.date}</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}